const get = property => (state) => (state[property])

export default {
  namespaced: true,
  state: {
    uploaded: {},
  },
  getters: {
    uploaded: get('uploaded'),
  },
  mutations: {
    setConstructionPhotoUploaded: (state, args) => {
      state['uploaded'][args.cloudConstructionId] = args.photoUploadedAt
    }
  },
  actions: {
    setConstructionPhotoUploaded({ commit }, args){
      commit('setConstructionPhotoUploaded', args) 
    }
  }
}
